import { useState, useEffect } from "react";
import {
  degrees,
  IndexOutOfBoundsError,
  last,
  PDFDocument,
  rgb,
  StandardFonts,
} from "pdf-lib";
import PDFTEMPLATE from "../assets/flyers/temp6.pdf";
import OTHLLogo from "../assets/images/OTHL-logo.png";
import fontkit from "@pdf-lib/fontkit";
import RobotoFont from "../assets/fonts/Roboto-Medium.ttf";
import MinionFont from "../assets/fonts/MinionPro-Regular.otf";
import ArlialnFont from "../assets/fonts/ARIALN.ttf";
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf";

async function makeFlyerTemplateSix(
  userData,
  previewOrDownload,
  setLoading,
  enableCobranding,
  cobrandHeadshot
) {
  let url = userData.flyerChoice.filePath;
  let brandColorObj = userData.brand.rgbHeader;
  let headerColor = rgb(brandColorObj[0], brandColorObj[1], brandColorObj[2]);

  let brandCtaColorObj = userData.brand.rgbCta;
  let ctaColor = rgb(
    brandCtaColorObj[0],
    brandCtaColorObj[1],
    brandCtaColorObj[2]
  );

  if (window.location.hostname === "localhost") {
    url = PDFTEMPLATE;
  }

  let person = userData.userData;
  const existingPdfBytes = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  }).then((res) => res.arrayBuffer());

  const fontBytesforRoboto = await fetch(RobotoFont).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforMinion = await fetch(MinionFont).then((res) =>
    res.arrayBuffer()
  );
  const fontBytesforArlian = await fetch(ArlialnFont).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforRobotoBold = await fetch(RobotoBold).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  pdfDoc.registerFontkit(fontkit);
  const robotoFontCondensed = await pdfDoc.embedFont(fontBytesforRoboto);
  const robotoBold = await pdfDoc.embedFont(fontBytesforRobotoBold);
  const arlianFont = await pdfDoc.embedFont(fontBytesforArlian);
  const minionFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  let innerPages = pages.slice(1, pages.length - 1);
  let lastPage = pages[pages.length - 1];

  const { width, height } = firstPage.getSize();

  // ADDING LOGO TO FIRST PAGE
  const colorLogoUrl = userData.brand.LogoUrl;
  console.log(colorLogoUrl);
  const colorLogoImageBytes = await fetch(colorLogoUrl).then((res) =>
    res.arrayBuffer()
  );
  const colorLogoImage = await pdfDoc.embedPng(colorLogoImageBytes);
  let colorLogoDims = colorLogoImage.scale(0.5);
  let imageWidthPlacement = 85;
  let imageHeightPlacement = height - colorLogoDims.height - 40;

  if (userData.brand.BrandName === "Tabor Mortgage") {
    colorLogoDims = colorLogoImage.scale(0.6);
    imageWidthPlacement = 130;
    imageHeightPlacement = height - colorLogoDims.height - 20;
  }

  firstPage.drawImage(colorLogoImage, {
    x: imageWidthPlacement,
    y: imageHeightPlacement,
    height: colorLogoDims.height,
    width: colorLogoDims.width,
  });

  // ADDING LOGO TO INNER PAGES
  const pngUrl = userData.brand.whiteLogoUrl;
  const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
  const pngImage = await pdfDoc.embedPng(pngImageBytes);
  let pngDims = pngImage.scale(0.6);

  pngDims = pngImage.scale(1.0);

  // ADDING LOGO TO LAST PAGE

  /// Second to Last Page Only
  //
  //
  //
  //
  /// Second to Last Page Only

  const secondToLastPage = pages[pages.length - 2];
  let textWidth = 100;
  let textHeight = 305;

  if (userData.userData.mloHeadshotFinal !== "") {
    const headshotImage = await fetch(person.mloHeadshotFinal).then((res) =>
      res.arrayBuffer()
    );
    const headshot = await pdfDoc.embedPng(headshotImage);
    if (userData.settings.user.headshot) {
      secondToLastPage.drawImage(headshot, {
        x: 105,
        y: 155,
        width: 200,
        height: 200,
      });
      textWidth = 340;
    }
  }

  secondToLastPage.drawText(
    `${person.FirstName.toUpperCase()} ${person.LastName.toUpperCase()}`,
    {
      x: textWidth,
      y: textHeight + 28,
      size: 30,
      font: robotoBold,
      color: rgb(1, 1, 1),
      weight: "bold",
    }
  );
  secondToLastPage.drawText(`${person.Title}`, {
    x: textWidth,
    y: textHeight,
    size: 17,
    font: robotoFontCondensed,
    color: rgb(1, 1, 1),
  });
  textHeight -= 25;
  if (person.LoanForce__NMLS_Number__c !== "") {
    secondToLastPage.drawText(`NMLS #${person.LoanForce__NMLS_Number__c}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
    textHeight -= 25;
  }

  if (userData.settings.user.mobileNumber) {
    secondToLastPage.drawText(`Mobile: ${person.Mobile_Phone_Formatted__c}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
    textHeight -= 25;
  }

  secondToLastPage.drawText(`Office:  ${person.Phone}`, {
    x: textWidth,
    y: textHeight,
    size: 17,
    font: robotoFontCondensed,
    color: rgb(1, 1, 1),
  });
  textHeight -= 25;

  if (userData.settings.user.faxNumber) {
    secondToLastPage.drawText(`Fax:  ${person.Fax}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
    textHeight -= 25;
  }

  secondToLastPage.drawText(`Email: ${person.Email}`, {
    x: textWidth,
    y: textHeight,
    size: 17,
    font: robotoFontCondensed,
    color: rgb(1, 1, 1),
  });
  textHeight -= 25;

  if (userData.settings.user.customMloWebsite === true) {
    secondToLastPage.drawText(`${userData.settings.user.customMloWebsiteUrl}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
  }

  let subDomainUrl = "contact/";

  if (
    userData.settings.user.mloWebsite &&
    !userData.settings.user.customMloWebsite
  ) {
    secondToLastPage.drawText(
      `Website: ${userData.brand.WebsiteUrl}${subDomainUrl}${person.Account}`,
      {
        x: textWidth,
        y: textHeight,
        size: 17,
        font: robotoFontCondensed,
        color: rgb(1, 1, 1),
      }
    );
  }

  // LICENSING INFORMATION
  //
  //
  //
  //
  //
  //
  //
  //
  //LICENSING INFORMATION

  secondToLastPage.drawText(`NMLS #${userData.branch.NMLS}`, {
    x: width - 850,
    y: 54,
    size: 8,
    font: arlianFont,
    color: rgb(1, 1, 1),
  });
  secondToLastPage.drawText(`${userData.branch.Address}`, {
    x: width - 705,
    y: 54,
    size: 8,
    font: arlianFont,
    color: rgb(1, 1, 1),
  });

  const ehoImageBytes = await fetch(
    "https://res.cloudinary.com/dqbckxsgm/image/upload/v1680284333/logos/Equal_Housing_Lender_White_7d1a033e.png"
  ).then((res) => res.arrayBuffer());
  const EHOImage = await pdfDoc.embedPng(ehoImageBytes);

  let ehoDims = EHOImage.scale(0.2);
  secondToLastPage.drawImage(EHOImage, {
    x: width - 905,
    y: 10,
    height: ehoDims.height,
    width: ehoDims.width,
  });

  let licensingText = `${userData.brand.licensingLineOne} ${userData.brand.licensingLineTwo} ${userData.brand.licensingLineThree} ${userData.brand.licensingLineFour}`;

  if (userData.flyerChoice.name.includes("Reverse Mortgage")) {
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );
    licensingText = licensingText + " " + userData.brand.reverseLicensing;
  }

  if (userData.flyerChoice.b2b) {
    licensingText = licensingText + " " + userData.flyerChoice.b2bLanguage;
  }

  const licensingTextWidth = minionFont.widthOfTextAtSize(licensingText, 10);
  const splitLicensing = licensingText.split(" ");

  let licensingHeight = 42;
  let licensingWidth = width - 850;
  let licensingTotalWidth = 650;
  if (userData.brand.BrandName === "The Bodner Team") {
    licensingTotalWidth = 585;
  }

  let LicensingLength = 0;
  let LicensingLine = "";
  let licensingLines = [];

  for (let i = 0; i < splitLicensing.length; i++) {
    let testLine = LicensingLine + splitLicensing[i] + " ";
    let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
    if (testWidth > licensingTotalWidth) {
      licensingLines.push(LicensingLine);
      LicensingLine = splitLicensing[i] + " ";
    } else {
      LicensingLine = testLine;
    }
  }
  licensingLines.push(LicensingLine);

  for (let i = 0; i < licensingLines.length; i++) {
    secondToLastPage.drawText(`${licensingLines[i]}`, {
      x: licensingWidth,
      y: licensingHeight,
      size: 10,
      font: minionFont,
      color: rgb(1, 1, 1),
    });
    licensingHeight -= 11;
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url2 = URL.createObjectURL(blob);
  console.log(blob, "here");

  if (previewOrDownload === "preview") {
    // set the name of the file
    window.open(url2, "_blank");
  }
  if (previewOrDownload === "download") {
    const link = document.createElement("a");
    link.href = url2;
    link.download = `${userData.flyerChoice.name}`;
    link.click();
  }
  setLoading(false);
  return pdfBytes;
}

export default makeFlyerTemplateSix;
